import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/** Shared centered loading indicator for page and content loading states. */
export default function PageLoader({ variant = "page", minHeight, label, sx = {} }) {
  const viewport = variant === "viewport";
  const region = variant === "region";

  return (
    <Box
      role="status"
      aria-label="Loading"
      sx={{
        width: "100%",
        height: region ? "100%" : undefined,
        minHeight: minHeight || (viewport ? "100vh" : region ? 240 : "calc(100vh - 64px)"),
        display: "flex",
        flexDirection: label ? "column" : "row",
        gap: label ? 1.5 : 0,
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        ...sx,
      }}
    >
      <CircularProgress size={48} thickness={4} sx={{ color: "#42A5F5" }} />
      {label && <Typography variant="body2" color="text.secondary">{label}</Typography>}
    </Box>
  );
}
